import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-nas-mac',
  templateUrl: './nas-mac.component.html',
  styleUrls: ['./nas-mac.component.css']
})
export class NasMacComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
